import { NextButton } from '../common/CommonStyled'
import { ExclusionType, RegionsType } from 'src/types/SchoolType'
import { putUserUpdate } from 'src/api/User'
import { refetchUser } from 'src/utils/RefetchUser'
import { useNavigate } from 'react-router-dom'

interface Props{
    disabled: boolean,
    area: RegionsType,
    email: string,
    phone: string
    name: string,
    include_arr:ExclusionType[]
}

export const ButtonSubmit = ({disabled, area, email, phone,include_arr, name}:Props) => {
  const highschool: number[] = [];
  const university: number[] = [];
  const navigate = useNavigate()
  //스쿨클래스 수정 필요
  include_arr.forEach((item) => {
    if (item.school_class === "고등학교") {
      highschool.push(item.school_id);
    } else if (item.school_class === "대학교"){
      university.push(item.school_id);
    } else{

    }
  });


  // 지역설정이 비어 있으면 전국 전체로 넣기
  // const regionArray: [string, string[]][] =
  // Object.keys(area).length === 0 ? [["전국", ["전체"]]] : Object.entries(area);
  // const isAreaValid = !area || Object.keys(area).length === 0
  //원래 의도
  const regionArray: [string, string[]][] = Object.entries(area);
  const handleSubmit = async()=>{
      await putUserUpdate({
        user_name:name,
        email:email,
        phone:phone,
        area:regionArray,
        include_highschool:highschool,
        include_university:university,
        exclude_highschool:[],
        exclude_university:[],
      })
      
      refetchUser()
      navigate('/home')
  }

  return (
    <NextButton disabled={disabled} onClick={()=>handleSubmit()}>수정 완료</NextButton>
  )
}
